module.exports = __webpack_public_path__ + "img/asset-group-criticality.aee35f32.png";